import React, { useEffect } from 'react'
import ExtensionImage from '../../../images/extension-image.png'
import './last_step.scss'

const LastStep = (props) => {
  const { user_email, download_link } = props;
  useEffect(() => {
    console.log('Sending conversion')
    gtag('event', 'conversion', {'send_to': 'AW-10792868052/EeHACLfitrMDENSxuJoo'});
  }, [])

  return (
    <div className="page-onboarding">
      <section className="content">
        <Container>
          <div className="content-layout">
            <Stepper
              stepName="Chrome extension"
              customClass="page-onboarding-stepper"
              activeIndex={5}
              steprAmount={5}
            />
            <div className="page-onboarding-text">
            <div className="page-onboarding-title">Install the Chrome extension</div>
            <div className="page-onboarding-subtitle">
              Start improving your network connecting with the HubbleIQ Chrome extension.
              <div>
              <a href={download_link} target="_blank" className={'btn btn-lg btn-primary downloadButton'}>
                Install
              </a>
              </div>
            </div>
            </div>
            <div className="page-onboarding-aside">
              <div className="page-block page-block_border">
                <div className="extension-img">
                  <img src={ExtensionImage} className="img-responsive" alt="extension" />
                </div>
              </div>
            </div>
            <div className="page-onboarding-buttons">
            <Button
                className="button button-default-outlined"
                generaltype="default"
                onClick={() => window.location = onboard_step_path(4)}
              >
                Back
              </Button>
              <Button
                className="button button-default"
                generaltype="default"
                // onClick={() => window.location = onboard_step_path(5)}
              >
                Next
              </Button>
            </div>
          </div>
        </Container>
      </section>
    </div>           
  )
}

export default LastStep
